module.exports = __webpack_public_path__ + "media/images/icons/material/white-check-3aa6a3938de08db05e891bfcb9e4c96b.svg";